import { api } from "@services/baseURL";

export const SaveTipo = async (data) => {
  try {
    const response = await api.post('TipoServicoAssociado', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar tipo:', error);
    throw error;
  }
};

export const UpdateTipo = async (id, data) => {
  try {
    const response = await api.patch(`TipoServicoAssociado/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar tipo:', error.response?.data || error.message);
    throw error;
  }
};

export const DeleteTipo = async (id) => {
  try {
    await api.delete(`TipoServicoAssociado/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar tipo:', error);
    throw error;
  }
};

export const GetAllTipos = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('TipoServicoAssociado', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos tipos:', error);
    throw error;
  }
};

export const GetByIdTipo = async (id) => {
  try {
    const response = await api.get(`TipoServicoAssociado/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar tipo:', error);
    throw error;
  }
};

export default {
  SaveTipo,
  UpdateTipo,
  DeleteTipo,
  GetByIdTipo,
  GetAllTipos
};